var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.type === "form-not-available" || _vm.type === "invalid-share-link"
    ? _c(
        "div",
        { staticClass: "cog-wrapper cog-body" },
        [
          _vm.notAvailableMessage
            ? _c("c-content", {
                staticClass: "cog-confirmation__message",
                attrs: { content: _vm.notAvailableMessage }
              })
            : _vm._e()
        ],
        1
      )
    : _c("div", { staticClass: "cog-invalid-form cog-cognito cog-form" }, [
        _c(
          "div",
          { staticClass: "cog-form__container" },
          [
            _vm.type === "suspicious-content"
              ? [
                  _c("link", {
                    attrs: {
                      rel: "stylesheet",
                      href:
                        "https://fonts.googleapis.com/css?family=Open+Sans+Condensed:700&text=InvalidForm!"
                    }
                  }),
                  _vm._v(" "),
                  _c("h1", [_vm._v("Invalid Form!")]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "Our apologies, this form has been disabled due to suspicious content."
                    )
                  ])
                ]
              : _vm.type === "form-not-found"
              ? [
                  _c("link", {
                    attrs: {
                      rel: "stylesheet",
                      href:
                        "https://fonts.googleapis.com/css?family=Open+Sans+Condensed:700&text=Formnotfound!"
                    }
                  }),
                  _vm._v(" "),
                  _c("h1", [_vm._v("Form not found!")]),
                  _vm._v(" "),
                  _c("p", [
                    _vm._v(
                      "Sorry, the form you are looking for no longer exists."
                    )
                  ])
                ]
              : _vm._e()
          ],
          2
        )
      ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }